import * as React from "react";
import Select from "react-select";
import Loader from "./Loader";
import styled from "styled-components";
import ReactPaginate from "react-paginate";

const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const EmptyDiv = styled.div`
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const BottomBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5px;
`;
const SelectContainer = styled.div`
  width: 100px;
  display: inline-block;
`;

const SearchContainer = styled.div`
  position: relative;
  color: #aaa;
  font-size: 12px;
`;

const SearchIcon = styled.span`
  position: absolute;
  top: 14px;
  left: 13px;
`;

const SearchInput = styled.input`
  width: 300px;
  line-height: 12px;
  padding: 1px;
  background: white;
  border: 1px solid #aaa;
  border-radius: 5px;
  text-indent: 26px;
`;

interface ICourseUsers {
  id: number;
  name: string;
  job_title: string;
  title: string;
  percent_complete: number;
  progressable_type: string;
  roles: string[];
  created_at: string;
}

interface IProps {
  searchOnChange: (event) => void;
  searchOnKeyDown: (event) => void;
  searchValue: string;
  pagesSelectValue: any;
  pagesSelectOnChange: (selectedOption) => void;
  loading: boolean;
  data: any;
  rowDataCallback: (data) => any;
  totalPages: number;
  selectedPage: number;
  onPageChange: (data) => void;
  marginPagesDisplayed: number;
  pageRangeDisplayed: number;
  pageNumOptions: { value: number; label: string }[];
  tableHeadings: string[];
}

function SearchTable(props: IProps) {
  return (
    <>
      <TopBar>
        <SearchContainer>
          <SearchIcon className="fa fa-search" />
          <SearchInput
            type={"text"}
            placeholder={"Search"}
            onChange={props.searchOnChange}
            onKeyDown={props.searchOnKeyDown}
            value={props.searchValue}
          />
        </SearchContainer>
        <SelectContainer>
          <Select
            autosize={true}
            className={"SearchTable"}
            options={props.pageNumOptions}
            value={props.pagesSelectValue}
            onChange={props.pagesSelectOnChange}
            clearable={false}
          />
        </SelectContainer>
      </TopBar>
      {props.loading ? (
        <EmptyDiv>
          <Loader />
        </EmptyDiv>
      ) : (
        <>
          <table className={"table"}>
            <thead className={"thead-light"}>
              <tr>
                {props.tableHeadings.map((heading, key) => {
                  return (
                    <th scope="col" key={key}>
                      {heading}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>{props.data.map(props.rowDataCallback)}</tbody>
          </table>
          <BottomBar>
            <ReactPaginate
              previousLabel={"previous"}
              nextLabel={"next"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={props.totalPages}
              forcePage={props.selectedPage}
              marginPagesDisplayed={props.marginPagesDisplayed}
              pageRangeDisplayed={props.pageRangeDisplayed}
              onPageChange={props.onPageChange}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"}
            />
          </BottomBar>
        </>
      )}
    </>
  );
}

export default SearchTable;



// WEBPACK FOOTER //
// ./app/javascript/components/core/SearchTable.tsx